// How many decimals a proposal deposit is rounded to, per currency.
//
// The server charges `stripeMinorUnits(amount, currency)` (Workspace369-API
// functions-payments/src/shared/stripeMinorUnits.ts): Math.round to whole
// units for the zero-decimal currencies (and for ISK / UGX, which Stripe takes
// whole), hundredths for everything else (three-decimal KWD/BHD/... are rounded
// to hundredths first, then scaled). The page must show the amount Stripe will
// charge, so it rounds the same way. KEEP THE LISTS IN SYNC with that file.

/** Stripe's zero-decimal currencies, plus ISK / UGX (whole units only). */
const WHOLE_UNIT_CURRENCIES: ReadonlySet<string> = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
  'ISK', 'UGX',
])

/** Decimal places a deposit in `currencyCode` is shown and charged with: 0 or 2. */
export function depositDecimals(currencyCode?: unknown): 0 | 2 {
  if (typeof currencyCode !== 'string') return 2
  return WHOLE_UNIT_CURRENCIES.has(currencyCode.trim().toUpperCase()) ? 0 : 2
}

/** `amount` rounded the way the server rounds it before charging. */
export function roundToCurrency(amount: number, currencyCode?: unknown): number {
  if (depositDecimals(currencyCode) === 0) return Math.round(amount)
  return Math.round(amount * 100) / 100
}
